// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
  GetFormsData,
  GetFormsResponses,
  PostVersionData,
  PostVersionResponses,
  PutFormData,
  PutFormResponses,
  SubmitErrorData,
  SubmitErrorResponses,
  SubmitFormData,
  SubmitFormResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const postVersion = <ThrowOnError extends boolean = false>(
  options: Options<PostVersionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PostVersionResponses,
    unknown,
    ThrowOnError
  >({
    url: "/versions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const getForms = <ThrowOnError extends boolean = false>(
  options: Options<GetFormsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetFormsResponses,
    unknown,
    ThrowOnError
  >({
    url: "/forms",
    ...options,
  });
};

export const putForm = <ThrowOnError extends boolean = false>(
  options: Options<PutFormData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    PutFormResponses,
    unknown,
    ThrowOnError
  >({
    url: "/forms/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const submitForm = <ThrowOnError extends boolean = false>(
  options: Options<SubmitFormData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SubmitFormResponses,
    unknown,
    ThrowOnError
  >({
    url: "/form-submissions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

export const submitError = <ThrowOnError extends boolean = false>(
  options: Options<SubmitErrorData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SubmitErrorResponses,
    unknown,
    ThrowOnError
  >({
    url: "/errors",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};
